import { render, staticRenderFns } from "./GeometrySection.vue?vue&type=template&id=cd0a3236&scoped=true&"
import script from "./GeometrySection.vue?vue&type=script&lang=js&"
export * from "./GeometrySection.vue?vue&type=script&lang=js&"
import style0 from "./GeometrySection.vue?vue&type=style&index=0&id=cd0a3236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0a3236",
  null
  
)

export default component.exports